import { render, staticRenderFns } from "./ueditor.vue?vue&type=template&id=1b8ad594"
import script from "./ueditor.vue?vue&type=script&lang=js"
export * from "./ueditor.vue?vue&type=script&lang=js"
import style0 from "./ueditor.vue?vue&type=style&index=0&id=1b8ad594&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports